"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SellwildPlugin = void 0;
const base_1 = require("../base");
class SellwildPlugin extends base_1.BasePlugin {
    generateMarkup(config) {
        const { id } = config;
        return `<div data-smart-slot="sellwild" id="${id}"></div>`;
    }
}
exports.SellwildPlugin = SellwildPlugin;
//# sourceMappingURL=index.js.map